import { routes as app } from '../app'

const root = [
  { path: '/', redirect: '/event' }
]

export default [ ...root, ...app ]



// WEBPACK FOOTER //
// ./src/router/routes.js